import { render, staticRenderFns } from "./SettingsMap.vue?vue&type=template&id=625fc7e2&scoped=true"
import script from "./SettingsMap.vue?vue&type=script&lang=js"
export * from "./SettingsMap.vue?vue&type=script&lang=js"
import style0 from "./SettingsMap.vue?vue&type=style&index=0&id=625fc7e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "625fc7e2",
  null
  
)

export default component.exports